import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {TableComponent, TableOptions} from "@shared/components";
import {APIService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {Allergy} from '@core/classes/tables/allergy';
import {HttpHeaders} from '@angular/common/http';
import {CurrentIllness} from '@core/classes/tables/current-illness';
import {NavigationEnd, Router} from '@angular/router';
import {
  ProblemDiagnosisStatusActionComponent
} from '@modules/cy/patient/ps/components/problems-diagnoses/actions/problem-diagnosis-status-action/problem-diagnosis-status-action.component';
import {
  AddProblemDiagnosisComponent
} from '@modules/cy/patient/ps/components/problems-diagnoses/actions/add-problem-diagnosis/add-problem-diagnosis.component';
import {
  SurgicalProcedureUnknownValuesComponent
} from '@modules/cy/patient/ps/components/surgical-procedures/actions/surgical-procedure-unknown-values/surgical-procedure-unknown-values.component';
import {
  ProblemDiagnosisUnknownValuesComponent
} from '@modules/cy/patient/ps/components/problems-diagnoses/actions/problem-diagnosis-unknown-values/problem-diagnosis-unknown-values.component';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-problems-diagnoses',
    imports: [
        TableComponent
    ],
  templateUrl: './problems-diagnoses.component.html',
  styleUrl: './problems-diagnoses.component.scss',
})
export class ProblemsDiagnosesComponent implements OnInit {
  @ViewChild('problemsDiagnoses') public problemsDiagnoseesEl!: TableComponent<CurrentIllness>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<CurrentIllness>>(
    new TableOptions<CurrentIllness>({
      id: 'problemsDiagnoses',
      type: 'ProblemsDiagnoses',
      interface: CurrentIllness,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-current-illness',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<CurrentIllness>({
            id: 'problemsDiagnoses',
            type: 'ProblemsDiagnoses',
            interface: CurrentIllness,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? ProblemDiagnosisStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddProblemDiagnosisComponent : undefined,
            extraLeftComponent: ProblemDiagnosisUnknownValuesComponent,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            otherData: response.unknown,
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as CurrentIllness;
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        );
      }
    })
  }
}
